import React, { FC } from 'react';
import styled from 'styled-components';
import NextAOTD from './nextAOTD';

interface AOTDStatsProps {
    generationElapsedTime?: string;
    nextAOTDEmojis?: string[];
    views?: {
        verified: number;
        total: number;
    };
    hasPermission?: boolean;
}

const StatsContainer = styled.div`
  margin-top: 15px;
  font-size: 0.75rem;
  color: #666;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const StatItem = styled.div`
  display: flex;
  align-items: center;
`;

const AOTDStats: FC<AOTDStatsProps> = ({
    generationElapsedTime,
    nextAOTDEmojis,
    views,
    hasPermission
}) => {
    // Only render if we have at least one stat to show
    const hasStats = generationElapsedTime || (nextAOTDEmojis && nextAOTDEmojis.length > 0) || views !== undefined;

    if (!hasStats) return null;

    return (
        <StatsContainer>

            {generationElapsedTime && (
                <StatItem>
                    <span className="text-xs text-gray-400">
                        <span className="italic">generated in</span> <b>{generationElapsedTime}</b>
                    </span>
                </StatItem>
            )}

            {views && views.total > 0 && views.verified > 0 && (
                <StatItem>
                    <span className="text-xs text-gray-400">
                        <b>{views.verified}</b> <span className="italic">user view{views.verified === 1 ? '' : 's'}</span> (<b>{views.total}</b> <span className="italic">total</span>)
                    </span>
                </StatItem>
            )}

            {hasPermission && nextAOTDEmojis && nextAOTDEmojis.length > 0 && (
                <StatItem>
                    <span className="text-gray-400 flex items-center">
                        <span className="text-xs italic">your next AOTD emojis:</span>
                        <span className="font-bold text-base ml-1 leading-none">{nextAOTDEmojis?.join(' ')}</span>
                    </span>
                </StatItem>
            )}
        </StatsContainer>
    );
};

export default AOTDStats;
